import React, {useContext, useState} from 'react';
import {Link, useLocation} from "react-router-dom";
import logo from "../../assets/images/logo/logo.svg"
import dashboardicon from "../../assets/images/icons/dashboardicon.svg"
import apiIcon from "../../assets/images/icons/apiIcon.svg"
import Settingicon from "../../assets/images/icons/Settingicon.svg"
import logouricon from "../../assets/images/icons/logouticon.svg"
import billingicon from "../../assets/images/icons/billingIcon.svg"
import pricingicon from "../../assets/images/icons/pricingicon.svg"
import mailIcon from "../../assets/images/icons/mailIcon.svg"
import helpIcon from "../../assets/images/icons/helpIcon.svg"
import {ReactSVG} from "react-svg";
import ConfirmationModel from "../ConfirmationModel";
import authContext from "../../AuthProvider/authContext";
import localized from "../../i18n";
import logoIcon from "../../assets/images/logo-icon.svg"
import {MdNavigateBefore} from "react-icons/md";
import axios from "axios";
import {handleError} from "../HandleError";

const Sidebar = () => {
    const location = useLocation();
    const {logout, state, updateAuth} = useContext(authContext);
    const [showLogoutModel, setLogoutModel] = useState(false);
    const [toggleSidebar, setToggleSidebar] = useState(false);

    const toggleLogoutModel = () => {
        setLogoutModel(!showLogoutModel);
    }

    const handleManageSubscription = () => {
        axios.get("/api/subscription")
            .then((response) => {
                window.open(response.data.data,  '_blank');
            }).catch((err) => {
            handleError(err);
        })
    };

    console.log("state", state);

    return (
        <div className={`sidebar-container ${toggleSidebar ? "hideSidebar":""}`}>
            <div className={"sidebar-toggle cursor-pointer"} onClick={()=>{setToggleSidebar(!toggleSidebar)}}>
                <MdNavigateBefore/>
            </div>
            <div className="sidebar-logo">
                {toggleSidebar ? <img src={logoIcon} alt="logo"/> : <img src={logo} alt="logo" style={{paddingLeft:"20px"}}/>}
            </div>
            <nav className="navbar-main">
                <ul>
                    {state.auth.role &&
                    <>
                    {state.auth.role === 2 ?
                            <>
                                <li className={`sidebar-nav-items ${location.pathname === "/dashboard" ? "active" : ""} `}>
                                    <Link to={"/dashboard"} className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={dashboardicon}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.verify_email}</div>
                                    </Link>
                                </li>
                                <li className={`sidebar-nav-items ${location.pathname === '/api-documentation' ? "active" : ""} `}>
                                    <Link to={'/api-documentation'} className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={apiIcon}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.API}</div>
                                    </Link>
                                </li>
                                <li className={`sidebar-nav-items ${location.pathname === "/settings" ? "active" : ""} `}>
                                    <Link to={"/settings"} className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={Settingicon}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.Settings}</div>
                                    </Link>
                                </li>
                                <li className={`sidebar-nav-items ${location.pathname === "/invoices" ? "active" : ""} `}>
                                    <Link to={"/invoices"} className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={billingicon}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.Billing}</div>
                                    </Link>
                                </li>
                                <li className={`sidebar-nav-items ${location.pathname === "/pricing-plan" ? "active" : ""} `}>
                                    <Link to={"/pricing-plan"} className="sidebar-nav-link">
                                        <div className="sidebar-nav-icon">
                                            <ReactSVG src={pricingicon} className={"price-icon"}/>
                                        </div>
                                        <div className="sidebar-nav-title">{localized.Pricing}</div>
                                    </Link>
                                </li>
                                {state.auth.stripe_customer_id && (
                                    <li className={`sidebar-nav-items`}>
                                        <div className="sidebar-nav-link" onClick={() => handleManageSubscription()}>
                                            <div className="sidebar-nav-icon">
                                                <ReactSVG src={pricingicon} className={"price-icon"}/>
                                            </div>
                                            <div className="sidebar-nav-title">{localized.Subscription}</div>
                                        </div>
                                    </li>
                                )}
                            </>
                            :
                            <li className={`sidebar-nav-items ${location.pathname === "/admin-dashboard" ? "active" : ""} `}>
                                <Link to={"/admin-dashboard"} className="sidebar-nav-link">
                                    <div className="sidebar-nav-icon">
                                        <ReactSVG src={dashboardicon}/>
                                    </div>
                                    <div className="sidebar-nav-title">Users</div>
                                </Link>
                            </li>
                    }
                        </>
                    }
                </ul>
                <ul>
                    <li className="sidebar-nav-items" >
                        <div className={`sidebar-nav-link}`}>
                            <a href="https://verif.email/faq/" target="_blank">
                                <div className="sidebar-nav-link">
                                    <div className="sidebar-nav-icon">
                                        <ReactSVG src={helpIcon} height="20px"/>
                                    </div>
                                    <div className="sidebar-nav-title">{localized.FAQ}</div>
                                </div>
                            </a>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li className="sidebar-nav-items" >
                        <div className={`sidebar-nav-link`}>
                            <a href="https://verif.email/contact/" target="_blank">
                                <div className="sidebar-nav-link">
                                    <div className="sidebar-nav-icon">
                                        <ReactSVG src={mailIcon}/>
                                    </div>
                                    <div className="sidebar-nav-title">{localized.Support}</div>
                                </div>
                            </a>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li className="sidebar-nav-items active" onClick={toggleLogoutModel}>
                        <div className="sidebar-nav-link ">
                            <div className="sidebar-nav-icon">
                                <ReactSVG src={logouricon} className="logout-icon"/>
                            </div>
                            <div className="sidebar-nav-title">{localized.Logout}</div>
                        </div>
                    </li>
                </ul>
            </nav>
            <ConfirmationModel
                title={localized.are_you_sure_want_to_logout}
                isOpen={showLogoutModel}
                disabled={state.isSubmitting}
                submitBtn={localized.Logout}
                className={"logout-modal"}
                onClose={toggleLogoutModel}
                onSubmit={() => logout(true)}
            />
        </div>
    );
};

export default Sidebar;